module.exports = __webpack_public_path__ + "ec4f730d9fbd05036dad35df17cc357f.png";